import React from "react";
import mediaQuery from "css-mediaquery";
import { createTheme, ThemeProvider } from "@mui/material";

type Props = {
  children: any;
  deviceType: any;
};

const getCssVariableValue = (variable: string, defaultValue: string) => {
  if (typeof window !== "undefined") {
    const value = getComputedStyle(document.documentElement)
      .getPropertyValue(variable)
      .trim();
    return value || defaultValue;
  }
  return defaultValue; // Return the default value for SSR
};

export default function MuiThemeProvider({
  children,
  deviceType: { mobile, tablet },
}: Props) {
  const ssrMatchMedia = (query: any) => ({
    matches: mediaQuery.match(query, {
      width: mobile ? "360px" : tablet ? "768px" : "1140px",
    }),
  });

  const theme = createTheme({
    components: {
      MuiUseMediaQuery: {
        defaultProps: {
          ssrMatchMedia,
        },
      },
    },
    palette: {
      primary: {
        main: getCssVariableValue("--primary", "#000000"), // Use a default color if the CSS variable is not defined
      },
    },
  });

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
